import moment from 'moment';
import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { luftGet, luftPost, luftPut, luftDelete } from '../../src/shared/http';
import { measurementUnit } from '../components/MeasurementValue';

// actions
const ADD_FORECAST_PERIOD = 'luft/dashboard-forecast/ADD_FORECAST_PERIOD';
const ADD_FORECAST_PERIOD_SUCCESS =
  'luft/dashboard-forecast/ADD_FORECAST_PERIOD_SUCCESS';
const ADD_FORECAST_PERIOD_FAILURE =
  'luft/dashboard-forecast/ADD_FORECAST_PERIOD_FAILURE';
const ADD_FORECAST_PERIOD_CLEAR =
  'luft/dashboard-forecast/ADD_FORECAST_PERIOD_CLEAR';

const UPDATE_FORECAST_PERIOD = 'luft/dashboard-forecast/UPDATE_FORECAST_PERIOD';
const UPDATE_FORECAST_PERIOD_SUCCESS =
  'luft/dashboard-forecast/UPDATE_FORECAST_PERIOD_SUCCESS';
const UPDATE_FORECAST_PERIOD_FAILURE =
  'luft/dashboard-forecast/UPDATE_FORECAST_PERIOD_FAILURE';
const UPDATE_FORECAST_PERIOD_CLEAR =
  'luft/dashboard-forecast/UPDATE_FORECAST_PERIOD_CLEAR';

const REMOVE_FORECAST_PERIOD = 'luft/dashboard-forecast/REMOVE_FORECAST_PERIOD';
const REMOVE_FORECAST_PERIOD_SUCCESS =
  'luft/dashboard-forecast/REMOVE_FORECAST_PERIOD_SUCCESS';
const REMOVE_FORECAST_PERIOD_FAILURE =
  'luft/dashboard-forecast/REMOVE_FORECAST_PERIOD_FAILURE';
const REMOVE_FORECAST_PERIOD_CLEAR =
  'luft/dashboard-forecast/REMOVE_FORECAST_PERIOD_CLEAR';

const GET_FORECAST_PERIOD = 'luft/dashboard-forecast/GET_FORECAST_PERIOD';
const GET_FORECAST_PERIOD_SUCCESS =
  'luft/dashboard-forecast/GET_FORECAST_PERIOD_SUCCESS';
const GET_FORECAST_PERIOD_FAILURE =
  'luft/dashboard-forecast/GET_FORECAST_PERIOD_FAILURE';
const GET_FORECAST_PERIOD_CLEAR =
  'luft/dashboard-forecast/GET_FORECAST_PERIOD_CLEAR';

const GET_FORECAST = 'luft/dashboard-forecast/GET_FORECAST';
const GET_FORECAST_SUCCESS = 'luft/dashboard-forecast/GET_FORECAST_SUCCESS';
const GET_FORECAST_FAILURE = 'luft/dashboard-forecast/GET_FORECAST_FAILURE';

const GET_FORECAST_DETAILS = 'luft/dashboard-forecast/GET_FORECAST_DETAILS';
const GET_FORECAST_DETAILS_SUCCESS =
  'luft/dashboard-forecast/GET_FORECAST_DETAILS_SUCCESS';
const GET_FORECAST_DETAILS_FAILURE =
  'luft/dashboard-forecast/GET_FORECAST_DETAILS_FAILURE';

const CHANGE_FORECAST_VIEW_UNIT =
  'luft/dashboard-forecast/CHANGE_FORECAST_VIEW_UNIT';
const CHANGE_DETAILS_GROUP_TYPE =
  'luft/dashboard-forecast/CHANGE_DETAILS_GROUP_TYPE';
const CHANGE_FORECAST_CURRENT_PERIOD =
  'luft/dashboard-forecast/CHANGE_FORECAST_CURRENT_PERIOD';

// maps

export const groupedDetailsTypes = {
  BRAND: 0,
  PRODUCT: 1,
  CLIENT: 2,
  REGION: 3,
};

export const groupedDetailsTypesToLabel = {
  [groupedDetailsTypes.BRAND]: 'Marca',
  [groupedDetailsTypes.PRODUCT]: 'Produto',
  [groupedDetailsTypes.CLIENT]: 'Cliente',
  [groupedDetailsTypes.REGION]: 'Região',
};

export const getForecastGroupedDetailsLabel = detailType =>
  groupedDetailsTypesToLabel[detailType];

// store initial state
const initialState = {
  addForecastPeriod: {
    isFetching: false,
    error: '',
    requested: '',
  },
  updateForecastPeriod: {
    isFetching: false,
    error: '',
    requested: '',
  },
  removeForecastPeriod: {
    isFetching: false,
    error: '',
    requested: '',
  },
  forecastPeriodList: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  forecast: {
    isFetching: false,
    error: '',
    requested: '',
    data: {
      bigNumbers: {
        value: {
          projectedOnPeriod: 0,
          projectedCurrent: 0,
          fulfilledCurrent: 0,
        },
        pallets: {
          projectedOnPeriod: 0,
          projectedCurrent: 0,
          fulfilledCurrent: 0,
        },
        volume: {
          projectedOnPeriod: 0,
          projectedCurrent: 0,
          fulfilledCurrent: 0,
        },
        units: {
          projectedOnPeriod: 0,
          projectedCurrent: 0,
          fulfilledCurrent: 0,
        },
      },
      projectedFulfilledChartData: [],
    },
  },
  forecastDetails: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  forecastViewUnit: measurementUnit.VALUE,
  groupedDetailsType: groupedDetailsTypes.PRODUCT,
  currentForecastPeriodId: null,
};

// UTIL

const calcDiffToProjected = el =>
  el.fulfilled !== null ? el.projected - el.fulfilled : null;

const getSortedPeriodList = periodList =>
  periodList
    ? periodList.sort(
        (a, b) =>
          moment(a.periodStartDate, 'DD/MM/YYYY') -
          moment(b.periodStartDate, 'DD/MM/YYYY'),
      )
    : [];

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_FORECAST_PERIOD:
      return {
        ...state,
        addForecastPeriod: {
          ...state.addForecastPeriod,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case ADD_FORECAST_PERIOD_SUCCESS: {
      return {
        ...state,
        addForecastPeriod: {
          ...state.addForecastPeriod,
          isFetching: false,
          error: '',
        },
        forecastPeriodList: {
          ...state.forecastPeriodList,
          data: getSortedPeriodList(action.data),
        },
      };
    }

    case ADD_FORECAST_PERIOD_FAILURE:
      return {
        ...state,
        addForecastPeriod: {
          ...state.addForecastPeriod,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_FORECAST_PERIOD_CLEAR:
      return {
        ...state,
        addForecastPeriod: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_FORECAST_PERIOD:
      return {
        ...state,
        updateForecastPeriod: {
          ...state.updateForecastPeriod,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case UPDATE_FORECAST_PERIOD_SUCCESS:
      return {
        ...state,
        updateForecastPeriod: {
          ...state.updateForecastPeriod,
          isFetching: false,
          error: '',
        },
        forecastPeriodList: {
          ...state.forecastPeriodList,
          data: getSortedPeriodList(action.data),
        },
      };

    case UPDATE_FORECAST_PERIOD_FAILURE:
      return {
        ...state,
        updateForecastPeriod: {
          ...state.updateForecastPeriod,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_FORECAST_PERIOD_CLEAR:
      return {
        ...state,
        updateForecastPeriod: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case REMOVE_FORECAST_PERIOD:
      return {
        ...state,
        removeForecastPeriod: {
          ...state.removeForecastPeriod,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case REMOVE_FORECAST_PERIOD_SUCCESS: {
      const listWithoutRemovedPeriod = state.forecastPeriodList.data.filter(
        el => el.id !== action.periodId,
      );
      return {
        ...state,
        removeForecastPeriod: {
          ...state.removeForecastPeriod,
          isFetching: false,
          error: '',
        },
        forecastPeriodList: {
          ...state.forecastPeriodList,
          data: listWithoutRemovedPeriod,
        },
        currentForecastPeriodId:
          state.currentForecastPeriodId === action.periodId
            ? listWithoutRemovedPeriod.length > 0
              ? listWithoutRemovedPeriod[0].id
              : null
            : state.currentForecastPeriodId,
      };
    }

    case REMOVE_FORECAST_PERIOD_FAILURE:
      return {
        ...state,
        removeForecastPeriod: {
          ...state.removeForecastPeriod,
          isFetching: false,
          error: action.error,
        },
      };

    case REMOVE_FORECAST_PERIOD_CLEAR:
      return {
        ...state,
        removeForecastPeriod: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_FORECAST_PERIOD:
      return {
        ...state,
        forecastPeriodList: {
          ...state.forecastPeriodList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_FORECAST_PERIOD_SUCCESS: {
      const periodList = action.data;
      const sortedPeriodList = getSortedPeriodList(periodList);
      return {
        ...state,
        forecastPeriodList: {
          ...state.forecastPeriodList,
          isFetching: false,
          error: '',
          data: sortedPeriodList,
        },
        currentForecastPeriodId:
          sortedPeriodList.length > 0 ? sortedPeriodList[0].id : null,
      };
    }

    case GET_FORECAST_PERIOD_FAILURE:
      return {
        ...state,
        forecastPeriodList: {
          ...state.forecastPeriodList,
          isFetching: false,
          error: action.error,
        },
      };

    case GET_FORECAST_PERIOD_CLEAR:
      return {
        ...state,
        forecastPeriodList: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    // ==========================
    // FORECAST
    // ==========================
    case GET_FORECAST:
      return {
        ...state,
        forecast: {
          ...state.forecast,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_FORECAST_SUCCESS:
      return {
        ...state,
        forecast: {
          ...state.forecast,
          received: action.received,
          isFetching: false,
          error: '',
          data: {
            ...action.data,
            projectedFulfilledChartData:
              action.data.projectedFulfilledChartData.map(el => ({
                referenceDate: moment(el.referenceDate).format('DD/MM'),
                fullDate: moment(el.referenceDate).format('DD/MM/YYYY'),
                value: {
                  ...el.value,
                  diffToProjected: calcDiffToProjected(el.value),
                },
                pallets: {
                  ...el.pallets,
                  diffToProjected: calcDiffToProjected(el.pallets),
                },
                volume: {
                  ...el.volume,
                  diffToProjected: calcDiffToProjected(el.volume),
                },
                weight: {
                  ...el.weight,
                  diffToProjected: calcDiffToProjected(el.weight),
                },
                units: {
                  ...el.units,
                  diffToProjected: calcDiffToProjected(el.units),
                },
              })),
          },
        },
      };

    case GET_FORECAST_FAILURE:
      return {
        ...state,
        forecast: {
          ...state.forecast,
          isFetching: false,
          error: action.error,
        },
      };

    // ==========================
    // FORECAST DETAILS
    // ==========================
    case GET_FORECAST_DETAILS:
      return {
        ...state,
        forecastDetails: {
          ...state.forecastDetails,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_FORECAST_DETAILS_SUCCESS:
      return {
        ...state,
        forecastDetails: {
          ...state.forecastDetails,
          received: action.received,
          isFetching: false,
          error: '',
          data: action.data,
        },
      };

    case GET_FORECAST_DETAILS_FAILURE:
      return {
        ...state,
        forecastDetails: {
          ...state.forecastDetails,
          isFetching: false,
          error: action.error,
        },
      };

    case CHANGE_FORECAST_VIEW_UNIT:
      return {
        ...state,
        forecastViewUnit: action.viewUnit,
      };

    case CHANGE_DETAILS_GROUP_TYPE:
      return {
        ...state,
        groupedDetailsType: action.groupType,
      };

    case CHANGE_FORECAST_CURRENT_PERIOD:
      return {
        ...state,
        currentForecastPeriodId: action.periodId,
      };

    default:
      return state;
  }
}

// action creators
function _addForecastPeriod() {
  return { type: ADD_FORECAST_PERIOD };
}

function _addForecastPeriodSuccess(data) {
  return {
    type: ADD_FORECAST_PERIOD_SUCCESS,
    data,
  };
}

function _addForecastPeriodFailure(error) {
  return {
    type: ADD_FORECAST_PERIOD_FAILURE,
    error,
  };
}

export function addForecastPeriodClear() {
  return { type: ADD_FORECAST_PERIOD_CLEAR };
}

function _updateForecastPeriod() {
  return { type: UPDATE_FORECAST_PERIOD };
}

function _updateForecastPeriodSuccess(data) {
  return {
    type: UPDATE_FORECAST_PERIOD_SUCCESS,
    data,
  };
}

function _updateForecastPeriodFailure(error) {
  return {
    type: UPDATE_FORECAST_PERIOD_FAILURE,
    error,
  };
}

export function updateForecastPeriodClear() {
  return { type: UPDATE_FORECAST_PERIOD_CLEAR };
}

function _getForecastPeriods() {
  return { type: GET_FORECAST_PERIOD };
}

function _getForecastPeriodsSuccess(data) {
  return {
    type: GET_FORECAST_PERIOD_SUCCESS,
    data,
  };
}

function _getForecastPeriodsFailure(error) {
  return {
    type: GET_FORECAST_PERIOD_FAILURE,
    error,
  };
}

export function getForecastPeriodClear() {
  return { type: GET_FORECAST_PERIOD_CLEAR };
}

function _removeForecastPeriod() {
  return { type: REMOVE_FORECAST_PERIOD };
}

function _removeForecastPeriodSuccess(periodId) {
  return {
    type: REMOVE_FORECAST_PERIOD_SUCCESS,
    periodId,
  };
}

function _removeForecastPeriodFailure(error) {
  return {
    type: REMOVE_FORECAST_PERIOD_FAILURE,
    error,
  };
}

export function removeForecastPeriodClear() {
  return { type: REMOVE_FORECAST_PERIOD_CLEAR };
}

// ==========================
// FORECAST
// ==========================
function _getForecast() {
  return { type: GET_FORECAST };
}

function _getForecastSuccess(data) {
  return {
    type: GET_FORECAST_SUCCESS,
    data,
  };
}

function _getForecastFailure(error) {
  return {
    type: GET_FORECAST_FAILURE,
    error,
  };
}

// ==========================
// FORECAST DETAILS
// ==========================
function _getForecastDetails() {
  return { type: GET_FORECAST_DETAILS };
}

function _getForecastDetailsSuccess(data) {
  return {
    type: GET_FORECAST_DETAILS_SUCCESS,
    data,
  };
}

function _getForecastDetailsFailure(error) {
  return {
    type: GET_FORECAST_DETAILS_FAILURE,
    error,
  };
}

// Config
export function changeForecastCurrentPeriod(periodId) {
  return { type: CHANGE_FORECAST_CURRENT_PERIOD, periodId };
}

export function changeForecastViewUnit(viewUnit) {
  return { type: CHANGE_FORECAST_VIEW_UNIT, viewUnit };
}

export function changeGroupedDetailsType(groupType) {
  return { type: CHANGE_DETAILS_GROUP_TYPE, groupType };
}

// thunk action creators
export function getForecast(periodId) {
  return function (dispatch) {
    (async () => {
      dispatch(_getForecast());
      const params = { periodId };

      try {
        const response = await luftGet('/ProjectedFulfilled/GetAll', params);
        dispatch(_getForecastSuccess(response.data));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getForecastFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function getForecastDetails(periodId, groupedDetailsType) {
  return function (dispatch) {
    (async () => {
      dispatch(_getForecastDetails());
      const params = {
        periodId,
        groupedDetailsType,
      };

      try {
        const response = await luftGet(
          '/ProjectedFulfilled/ProjectedFulfilledDetails',
          params,
        );
        dispatch(_getForecastDetailsSuccess(response.data));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getForecastDetailsFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function getForecastPeriods() {
  return function (dispatch) {
    (async () => {
      dispatch(_getForecastPeriods());
      try {
        const response = await luftGet('/ProjectedFulfilled');
        dispatch(_getForecastPeriodsSuccess(response.data));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getForecastPeriodsFailure(error.message),
        );
      }
    })();
  };
}

export function addForecastPeriod(
  periodName,
  periodStartDate,
  periodEndDate,
  forecastItemList,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(_addForecastPeriod());

      const requestBody = {
        periodName,
        periodStartDate: moment(periodStartDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
        periodEndDate: moment(periodEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        forecastItemList,
      };

      try {
        const response = await luftPost('/ProjectedFulfilled', requestBody);
        dispatch(_addForecastPeriodSuccess(response.data));
        return true;
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _addForecastPeriodFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function updateForecastPeriod(
  id,
  periodName,
  periodStartDate,
  periodEndDate,
  forecastItemList,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(_updateForecastPeriod());

      const requestBody = {
        id,
        periodName,
        periodStartDate: moment(periodStartDate, 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        ),
        periodEndDate: moment(periodEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        forecastItemList,
      };

      try {
        const response = await luftPut('/ProjectedFulfilled', requestBody);
        dispatch(_updateForecastPeriodSuccess(response.data));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _updateForecastPeriodFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function removeForecastPeriod(periodId) {
  return function (dispatch) {
    return (async () => {
      dispatch(_removeForecastPeriod());

      const params = { periodId };

      try {
        await luftDelete('/ProjectedFulfilled', params);
        dispatch(_removeForecastPeriodSuccess(periodId));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _removeForecastPeriodFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}
